module.exports = __webpack_public_path__ + "static/media/vg.static.70531fe1.svg";